<style lang="scss" scoped>
    .module-section {
        font-size: 18px;

        .section-name {
            color: #4d8ab7;
            font-weight: 300;
            font-size: 1.1em;
        }
    }

    .modal-training-title {
        font-size: 2.0em;
        color: #fff;
    }

    .training-hr {
        margin-top: 5px;
        margin-bottom: 0.8em !important;
    }

    .font-size-3em {
        font-size: 3.0em;
    }

    .yanone {
        font-family: "Yanone Kaffeesatz", sans-serif;
    }

</style>


<template>
	<div>
        <dashboard-tabs :modules="modules">
            <template #primary="{ module }">
                <div class='text-center pt-3'>
                    <p>This Provider Trainings page allows you to view the same trainings as child care providers so you may familiarize yourself with the content and decide which trainings you may want to recommend to child care providers. This page does not include knowledge quizzes, evaluations, or the ability to take attendance and therefore cannot generate certificates.</p>

                    <p><strong>Do not use this page to host trainings for child care providers.</strong></p>

                    <p>If you would like to deliver a training using the Go NAPSACC training videos you <strong><u>must</u></strong> login to a child care provider’s Go NAPSACC account.  This gives you access to the training videos, knowledge quizzes and evaluations.  The only way for child care providers to receive completion certificates and be included in any training reports is to complete a training in a Go NAPSACC child care provider account.</p>
            	</div>
            </template>

            <template #secondary="{ module }">
                <div class="container" :class="'mx-0 p-4 border-'+ module.color +' border-top-0'">
                    <div class="row row-cols-2">
                        <div class="col module-section pb-5" v-for="training in trainingsInModule(module.id)" :key="training.id">
                            <div class="row">
                                <div class="col col-4">
                                    <div class="section-image img-wrapper-orange">
                                        <img :src="$basePath + '/images/summary/' + training.image_thumb" class="w-100" />
                                    </div>
                                </div>
                                <div class="col col-8">
                                    <div class="section-name yanone">
                                        <a href="#" @click="setCurrentContent('training-video-embed', training)" data-toggle="modal" data-target="#session-modal">
                                            {{training.title}}
                                        </a>
                                    </div>

                                    <hr class="training-hr" />

                                	<button type="button" class="play-btn btn btn-orange-blue" @click="setCurrentContent('training-video-embed', training)" data-toggle="modal" data-target="#session-modal">
                                		<i class="fa fa-play" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div :class="'build-the-skills row container mx-0 p-4 border-'+ module.color +' border-top-0'" v-if="isBuildTheSkillsDisplayed(module.slug)">
                    <build-the-skills
                        :user="user"
                        @select-content="setCurrentBuildTheSkillsContent"
                        :step-two-enabled="isBuildTheSkillsStepTwoEnabled"
                    >
                    </build-the-skills>
                </div>
            </template>

        </dashboard-tabs>

	</div>	

</template>

<script>

	import ModuleIcon from '../ModuleIcon';
    import DashboardTabs from '../dashboard_tabs/DashboardTabs';
    import TrainingVideoEmbed from './TrainingVideoEmbed.vue';
    import BuildTheSkills from '../BuildTheSkills/BuildTheSkills.vue';
    import BuildTheSkillsAssessment from './BuildTheSkillsAssessment.vue';
    import BuildTheSkillsVideo from './BuildTheSkillsVideo.vue';
    import BuildTheSkillsCertificate from './BuildTheSkillsCertificate.vue';
    import { mapState, mapGetters, mapMutations } from 'vuex';


    export default {
    	components: {
    		ModuleIcon,
			DashboardTabs,
            TrainingVideoEmbed,
            BuildTheSkills,
            BuildTheSkillsAssessment,
            BuildTheSkillsVideo,
            BuildTheSkillsCertificate   
    	},
    	props: {
            modules: {
                required: true,
                type: Array
            },
            user: {
                required: false,
                type: Object,
                default: null,
            },
    	},
    	data: () => {
    		return {
                currentTrainingId: null,
                currentComponent: null,
                currentVideoId: null,
                isBuildTheSkillsStepTwoEnabled: false,
    		};
    	},
    	methods: {
            initState() {
                let vm = this;

                axios.get('/provider-trainings/data' + (vm.programId ? "/program/" + vm.programId : ""))
                .then(response => {
                    let trainings = response.data.trainings; 
                    vm.initTrainings({trainings});
                });
            },
            setCurrentContent(component, training) {
                if(training) {
                    this.setCurrentTrainingId({currentTrainingId: training.id});
                }
                this.setCurrentContentComponent({currentContentComponent: component});
                this.setShowContent({showContent: true});
            },
            onContentModalHidden() {
                this.resetContent();
            },
            resetContent() {
                this.currentComponent = null;
                this.currentTrainingId = null;
                this.currentVideoId = null;
            },
            setCurrentBuildTheSkillsContent(component, userId) {
                this.setCurrentContent(component, null);
            },
            hasRole(role) {
                return Auth.is(role);
            },
            isBuildTheSkillsDisplayed(module_slug) {
                return module_slug == "infant-and-child-physical-activity" &&
                    this.hasRole('ta-consultant');
            },
            enableBuildTheSkillsStepTwo() {
                this.isBuildTheSkillsStepTwoEnabled = true;
            },
            ...mapMutations({
                initTrainings: 'INIT_TRAININGS',
                setCurrentTrainingId: 'SET_CURRENT_TRAINING_ID',
                setCurrentContentComponent: 'SET_CURRENT_CONTENT_COMPONENT',
                setShowContent: 'SET_SHOW_CONTENT',
            })
    	},
    	computed: {
            currentTraining: function() {
                if(this.currentTrainingId) {
                    return this.trainings[this.currentTrainingId];
                }
                return null;
            },
            trainingTitle: function() {
                if(this.currentTraining) {
                    return this.currentTraining.title;
                } else {
                    return "Build the Skills";
                }
            },
            moduleColor() {
                if(this.currentTraining && this.currentTraining.section && this.currentTraining.section.module) {
                   return this.currentTraining.section.module.color;
                } else {
                    return "primary";
                }
            },
            ...mapState([
                'trainings',
                'trainingSessions'
            ]),
            ...mapGetters([
                'trainingsInModule'
            ]),
    	},
        mounted: function() {
            this.initState();
        }
    }
	
</script>
